import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@repair-please/ui/tokens.css';
import '@repair-please/ui/ui.css';
import './app.css';
import { AppRoot } from './app-root.js';
import { rootErrorOptions } from './root-errors.js';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing #root element');

createRoot(rootElement, rootErrorOptions).render(
  <StrictMode>
    <AppRoot />
  </StrictMode>,
);
